// extracted by mini-css-extract-plugin
export default {"loginBox":"loginBox--m4mFD"};